import React from 'react';
import clsx from 'clsx';

export default function Card({ title, subtitle, actions, className, children }) {
  const hasHeader = title || subtitle || actions;

  return (
    <div
      className={clsx(
        'rounded-card bg-white shadow-card ring-1 ring-neutral-200/60',
        className
      )}
    >
      {hasHeader && (
        <div className="flex items-start justify-between gap-4 border-b border-neutral-100 px-6 py-4">
          <div className="min-w-0">
            {title && (
              <h3 className="truncate text-base font-semibold text-neutral-900 font-heading">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="mt-0.5 text-sm text-neutral-500">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          )}
        </div>
      )}
      <div className="px-6 py-4">{children}</div>
    </div>
  );
}
